import RootState from '@/store/root_state';
import { ActionTree } from 'vuex';
import { GDHState } from './state';
import {
  GrowthDataHubService,
  DataDto,
} from '@/services/undergrad/pegasus-silver/growth-data-hub.service';

const GDH_SERVICE_INDEX: string = 'lms';

const SET_GROWTH_DATA = 'SET_GROWTH_DATA';

export const getData = async (email: string): Promise<DataDto> => {
  return new GrowthDataHubService().getData({
    email,
    serviceIndex: GDH_SERVICE_INDEX,
  });
};

export const putData = async (email: string, data: any): Promise<DataDto> => {
  return new GrowthDataHubService().putData({
    email,
    serviceIndex: GDH_SERVICE_INDEX,
    serviceData: JSON.stringify(data),
  });
};

const actions: ActionTree<GDHState, RootState> = {
  async GET_GDH_DATA({ commit }, state): Promise<void> {
    const { email } = state;
    const data = await getData(email);

    if (!data) {
      return;
    }

    const { serviceData } = data;

    commit(SET_GROWTH_DATA, JSON.stringify(serviceData));
  },

  async CHANGE_GDH_DATA({ commit }, state): Promise<void> {
    const { email, serviceData } = state;
    const data = await putData(email, serviceData);

    if (!data) {
      return;
    }

    commit(SET_GROWTH_DATA, JSON.stringify(data.serviceData));
  },
};

export default actions;
